<template>
  <div>
    <section class="">
      <div class="container">
        <ul class="btn-box">
          <li>
            <router-link :to="{ name: 'MemberInfo' }" tag="button">
              <img src="img/member-icon-1.svg" alt="" />
              {{ $t("會員資料") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'OrderList' }" tag="button">
              <img src="img/member-icon-2.svg" alt="" />
              {{ $t("我的套票") }}
            </router-link>
          </li>
          <li v-if="local != 'jp'">
            <router-link :to="{ name: 'CardInfo' }" tag="button">
              <img src="img/member-icon-6.svg" alt="" />
              {{ $t("卡片資料") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'Coupon' }" tag="button">
              <img src="img/member-icon-8.svg" alt="" />
              {{ $t("套票兌換") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'TradeRecord' }" tag="button">
              <img src="img/member-icon-4.svg" alt="" />
              {{ $t("卡片交易紀錄") }}
            </router-link>
          </li>
          <li v-if="local != 'jp'">
            <router-link :to="{ name: 'CarbonReduction' }" tag="button" class="active">
              <img src="img/member-icon-9.png" alt="" />
              {{ $t("減碳計算") }}
            </router-link>
          </li>
          <li v-if="local != 'jp'">
            <router-link :to="{ name: 'MemberCoupon' }" tag="button">
              <img src="img/member-icon-2.svg" alt="" />
              {{ $t("優惠專區") }}
            </router-link>
          </li>
          <li v-if="local != 'jp' && hasInvite">
            <router-link :to="{ name: 'InvitEvent' }" tag="button">
              <img src="img/member_icon_friends.svg" alt="" />
              {{ $t("邀請朋友") }}
            </router-link>
          </li>
          <li></li>
        </ul>
        <div class="main">
          <div class="img-box">
            <img src="img/tree-card-03-1.png" alt="" />
            <div class="text-box">
              <h2>{{ $t("我的減碳成效") }}</h2>
              <div class="text">
                <p>{{ $t("前一日減碳量") }}</p>
                <p>
                  {{ CarbonReductionLast }}KG
                </p>
              </div>
              <div class="text">
                <p>{{ $t("累積減碳量") }}</p>
                <p>{{ CarbonReductionTotal }}KG</p>
              </div>
              <p>
                {{ $t("減碳量自 110 年 8 月 15 日起開始累計，") }}
                <br />
                <span>{{ $t("系統將依資料來源定期更新顯示。") }}</span>
              </p>
              <!-- <template v-if="IsTester">
                <h2>{{ $t("我的減碳成效") }}</h2>
                <div class="text">
                  <p>{{ $t("前一日減碳量") }}</p>
                  <p>
                    {{ CarbonReductionLast }}KG
                  </p>
                </div>
                <div class="text">
                  <p>{{ $t("累積減碳量") }}</p>
                  <p>{{ CarbonReductionTotal }}KG</p>
                </div>
                <p>
                  {{ $t("自110年8月15四起開始累計，") }}
                  <span>{{ $t("系統將依資料來源定期更新顯示。") }}</span>
                </p>
              </template>
<template v-else>
                <h2>{{ $t("減碳量") }}</h2>
                <div class="text">
                  <p>{{ $t("前一個月減碳量") }}</p>
                  <p v-if="Day >= 15">
                    {{ CarbonReductionLastMonth }}KG
                  </p>
                  <p v-if="Day < 15">計算中</p>
                </div>
                <p>
                  <span>配合各運具資料計算與收集，於每月15、25日更新</span>
                </p>
                <div class="text">
                  <p>{{ $t("累積減碳量") }}</p>
                  <p>{{ CarbonReductionTotal }}KG</p>
                </div>
                <p>
                  {{ $t("自111年10月起搭乘計入減碳量。") }}
                  <br />
                  <span>{{ $t("自113年5月25日起改用環境部「淨零綠生活指引」運具排碳量計算。") }}</span>
                </p>
              </template> -->
              <template v-if="healthAvailable">
                <hr class="carbon_line">
                <template v-if="!healthAuthorization">
                  <div class="text">
                    <p>取得權限</p>
                    <p style="
                    font-size: 16px;
                    color: #fff;
                    background: #173042;
                    border: none;
                    border-radius: 5px;
                    padding: 5px 10px;
                    cursor: pointer;" @click="requestAuthorization()">
                      允許 MeN Go 存取您的運動記錄
                    </p>
                  </div>
                  <p class="pedometer_text">
                    <img src="/img/icon-exclamation.png" alt="">
                    允許 MeN Go 存取您的運動記錄，未來即可在此頁面上傳您的前日步數資料，並顯示前日及累積步數資料。
                  </p>
                </template>
                <template v-else>
                  <div class="text">
                    <p>前日步數</p>
                    <p>{{ yesterdayTotalSteps.toLocaleString() }} 步</p>
                  </div>
                  <template v-if="canUpdateSteps">
                    <div class="text" v-if="canUpdateSteps">
                      <p></p>
                      <p style="
                    font-size: 16px;
                    color: #fff;
                    background: #173042;
                    border: none;
                    border-radius: 5px;
                    padding: 5px 10px;
                    cursor: pointer;" @click="queryHealthData()">
                        重新取得步數資料
                      </p>
                    </div>
                    <div class="text" v-if="canUpdateSteps">
                      <p></p>
                      <p style="
                    font-size: 16px;
                    color: #fff;
                    background: #173042;
                    border: none;
                    border-radius: 5px;
                    padding: 5px 10px;
                    cursor: pointer;" @click="updateSteps()">
                        手動上傳
                      </p>
                    </div>
                  </template>
                  <template v-else>
                    <div class="text">
                      <p></p>
                      <p style="
                        font-size: 16px;
                        color: #fff;
                        background: #173042;
                        border: none;
                        border-radius: 5px;
                        padding: 5px 10px;
                        cursor: pointer;">
                        前日步數已上傳
                      </p>
                    </div>
                  </template>
                  <div class="text">
                    <p>總累積步數</p>
                    <p>{{ totalSteps.toLocaleString() }}步</p>
                  </div>
                  <p class="pedometer_text">
                    <img src="/img/icon-exclamation.png" alt="">
                    「步數統計係依據裝置內建之健康/步數應用所回傳的資料，系統不自行運算步數數據。若裝置未開啟相關權限或無數據，顯示內容將以內建應用提供為準。」
                  </p>
                </template>
              </template>
            </div>
            <!-- 新增圖片 -->
            <img src="img/tree-card-03-2.png" alt="" />
          </div>
        </div>
      </div>
    </section>
    <!-- 底部加高 底部固定選單fixed的高度 -->
    <div class="nav-menu-bg"></div>
  </div>
</template>

<script>
import Vue, { h } from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import AES from "@/utils/aes.js";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import VueI18n from "vue-i18n";
import Storage from "@/utils/storage.js";

Vue.use(VueAxios, axios);
Vue.use(VueSweetalert2);
Vue.use(VueI18n);

// this.$t("立即購買")
const messages = {
  zh_tw: {
    會員資料: "會員資料",
    我的套票: "我的套票",
    卡片資料: "卡片資料",
    套票兌換: "套票兌換",
    卡片交易記錄: "卡片交易記錄",
    錯誤: "錯誤",
    "取得交易紀錄過程發生錯誤, 請稍後再試一次":
      "取得交易紀錄過程發生錯誤, 請稍後再試一次",
    確定: "確定",
    累積減碳量: "累積減碳量",
    自111年8月15日起搭乘記入減碳量: "自111年8月15日起搭乘記入減碳量",
    每月20號統計更新: "每月20號統計更新",
    減碳量: "減碳量",
    前一個月減碳量: "前一個月減碳量",
    減碳計算: "減碳計算",
    卡片交易紀錄: "卡片交易紀錄",
  },
  en: {
    會員資料: "Member info",
    我的套票: "My pass",
    卡片資料: "Card info",
    套票兌換: "Redeem pass",
    卡片交易記錄: "Card record",
    錯誤: "Error",
    "取得交易紀錄過程發生錯誤, 請稍後再試一次": "Error. Please try again.",
    確定: "Confirm",
    累積減碳量: "Accumulated",
    自111年8月15日起搭乘記入減碳量:
      "Rides count into carbon reduction starting 15th Aug 2022.",
    每月20號統計更新: "Statistics updates on the 20th of every month.",
    減碳量: "Carbon Reduced",
    前一個月減碳量: "Last month",
    減碳計算: "Carbon Reduction",
    卡片交易紀錄: "Activity",
  },
  jp: {
    會員資料: "マイページ",
    我的套票: "購入/予約履歴",
    卡片資料: "卡片資料",
    套票兌換: "チケット引き換え",
    卡片交易記錄: "卡片交易記錄",
    錯誤: "エラー",
    "取得交易紀錄過程發生錯誤, 請稍後再試一次":
      "購入手続き中にエラーが発生しました,ご確認の上、再度お試しください",
    確定: "確定",
    累積減碳量: "累積減碳量",
    自111年8月15日起搭乘記入減碳量: "自111年8月15日起搭乘記入減碳量",
    每月20號統計更新: "每月20號統計更新",
    減碳量: "減碳量",
    前一個月減碳量: "前一個月減碳量",
    減碳計算: "減碳計算",
    卡片交易紀錄: "卡片交易紀錄",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "CarbonReduction",
  i18n,
  data() {
    return {
      CarbonReductionLastMonth: 0,
      CarbonReductionTotal: 0,
      CarbonReductionLast: 0,
      IsLoaded: false,
      local: "zh_tw",
      Day: 0,
      IsTester: false,
      hasInvite: false,
      isMobile:
        navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        ) != null,
      healthAvailable: false,
      healthAuthorization: false,
      healthData: [],
      totalSteps: 0,
      yesterdayTotalSteps: 0,
      canUpdateSteps: false,
    };
  },
  created: function () {
    const today = new Date();
    this.Day = today.getDate();
    let that = this;
    Vue.axios
      .get(
        this.GLOBAL.apiSrc +
        this.GLOBAL.subDirectory +
        "/Htmlv2/CarbonReduction",
        {
          params: {
            token: Storage.get("ek_login_token"),
          },
        }
      )
      .then((response) => {
        this.CarbonReductionLastMonth = response.data.CarbonReductionLastMonth;
        this.CarbonReductionTotal = response.data.CarbonReductionTotal;
        this.CarbonReductionLast = response.data.CarbonReductionLast;
        this.totalSteps = response.data.TotalSteps;
        this.canUpdateSteps = response.data.CanUpdateSteps;
        this.IsTester = response.data.IsTester;
        this.hasInvite = response.data.hasInvite;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: async function () {
    // 回頂端
    $(window).scrollTop(0);
    // 套用Class
    $(".wrapper").addClass("member");
    $(".wrapper").addClass("member-carbon");
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
    }
    this.local = i18n.locale;
    // 嘗試取得 Health Data
    await this.isAvailable();
    await this.isAuthorization();
    if (this.healthAvailable && this.healthAuthorization) {
      await this.queryHealthData();
      // 2026-03-26 改為進入頁面時自動上傳
      await this.updateSteps(true);
    }
  },
  methods: {
    timeString(time, format) {
      return moment(time).format(format || "YYYY-MM-DD, HH:mm:ss");
    },
    queryHealthData() {
      let that = this;
      return new Promise((resolve, reject) => {
        if (this.isMobile &&
          typeof cordova != "undefined" &&
          typeof cordova.plugins != "undefined" &&
          typeof cordova.plugins.health != "undefined") {

          // 取得前一天的日期
          const yesterday = new Date();
          yesterday.setDate(yesterday.getDate() - 1);
          yesterday.setHours(0, 0, 0, 0);
          const yesterdayEnd = new Date();
          yesterdayEnd.setDate(yesterdayEnd.getDate() - 1);
          yesterdayEnd.setHours(23, 59, 59, 999);
          cordova.plugins.health.query({
            startDate: yesterday, // 前一天 00:00:00
            endDate: yesterdayEnd, // 前一天 23:59:59
            dataType: 'steps',
            limit: 10000,
            ascending: true,
          },
            function (data) {
              that.healthData = data;
              // 解析 data 並計算昨日總步數
              that.yesterdayTotalSteps = 0;
              if (Array.isArray(data)) {
                data.forEach(item => {
                  if (item.value && typeof item.value === 'number') {
                    that.yesterdayTotalSteps += item.value;
                  }
                });
              }
              // that.$swal({
              //   heightAuto: false,
              //   title: that.$t("成功"),
              //   text: JSON.stringify(data),
              //   icon: "info",
              //   allowOutsideClick: false,
              //   confirmButtonText: that.$t("確定"),
              // });            
              resolve(data);
            },
            function (err) {
              // that.$swal({
              //   heightAuto: false,
              //   title: that.$t("錯誤"),
              //   text: err,
              //   icon: "error",
              //   allowOutsideClick: false,
              //   confirmButtonText: that.$t("確定"),
              // });
              reject(err);
            })
        } else {
          resolve();
        }
      });
    },
    isAvailable() {
      let that = this;
      return new Promise((resolve, reject) => {
        if (this.isMobile &&
          typeof cordova != "undefined" &&
          typeof cordova.plugins != "undefined" &&
          typeof cordova.plugins.health != "undefined") {
          cordova.plugins.health.isAvailable(
            function (result) {
              that.healthAvailable = result;
              resolve(result);
            },
            function (err) {
              console.log("Health Availability Check Error: " + err);
              that.healthAvailable = false;
              reject(err);
            }
          );
        } else {
          that.healthAvailable = false;
          resolve(false);
        }
      });
    },
    isAuthorization() {
      let that = this;
      return new Promise((resolve, reject) => {
        if (this.isMobile &&
          typeof cordova != "undefined" &&
          typeof cordova.plugins != "undefined" &&
          typeof cordova.plugins.health != "undefined") {
          cordova.plugins.health.isAuthorized(
            {
              read: ['steps'],
              ...(cordova.platformId === 'ios' ? { write: ['steps'] } : {}),
            },
            function (result) {
              that.healthAuthorization = result;
              resolve(result);
            },
            function (err) {
              console.log("Health Authorization Check Error: " + err);
              that.healthAuthorization = false;
              reject(err);
            },
          )
        } else {
          that.healthAuthorization = false;
          resolve(false);
        }
      });
    },
    async requestAuthorization() {
      let that = this;
      if (this.isMobile &&
        typeof cordova != "undefined" &&
        typeof cordova.plugins != "undefined" &&
        typeof cordova.plugins.health != "undefined") {
        cordova.plugins.health.requestAuthorization(
          {
            read: ['steps'],
            ...(cordova.platformId === 'ios' ? { write: ['steps'] } : {}),
          },
          async function () {
            await that.isAuthorization();
            if (that.healthAvailable && that.healthAuthorization) {
              await that.queryHealthData();
              // 2026-03-26 改為取得權限後馬上上傳步數資料
              await that.updateSteps(true);
            } else {
              that.$swal({
                heightAuto: false,
                title: that.$t("錯誤"),
                text: "無法取得權限，請至系統設定開啟相關權限",
                icon: "error",
                allowOutsideClick: false,
                confirmButtonText: that.$t("確定"),
              });
            }
            // that.$swal({
            //   heightAuto: false,
            //   title: that.$t("成功"),
            //   text: that.$t("授權成功"),
            //   icon: "info",
            //   allowOutsideClick: false,
            //   confirmButtonText: that.$t("確定"),
            //   willClose: function () {
            //     that.isAuthorized();
            //     this.queryHealthData();
            //   },
            // });
          },
          function (err) {
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: err,
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
          },
        )
      }
    },
    updateSteps(isSilence = false) {
      if (this.yesterdayTotalSteps > 0) {
        let that = this;
        $.ajax({
          url:
            that.GLOBAL.apiSrc +
            that.GLOBAL.subDirectory +
            "/Htmlv2/UpdatePedometerSteps",
          type: "post",
          data: {
            steps: that.yesterdayTotalSteps,
            token: Storage.get("ek_login_token"),
          },
          dataType: "json",
          async: false,
          error: function () {
            if (!isSilence) {
              that.$swal({
                heightAuto: false,
                title: that.$t("錯誤"),
                text: that.$t("更新過程發生錯誤, 請稍後再試一次"),
                icon: "error",
                allowOutsideClick: false,
                confirmButtonText: that.$t("確定"),
              });
            }
          },
          success: function (res) {
            // 判斷結果
            if (res.ok) {
              if (!isSilence) {
                that.totalSteps = res.TotalSteps;
                that.canUpdateSteps = false;
                that.$swal({
                  heightAuto: false,
                  title: that.$t("成功"),
                  text: that.$t("步數資料已更新"),
                  icon: "success",
                  allowOutsideClick: false,
                  confirmButtonText: that.$t("確定"),
                });
              }
            } else if (res.error_msg) {
              if (!isSilence) {
                var error_msg = JSON.parse(res.error_msg);
                if (res.toekn_error) {
                  that.$swal({
                    heightAuto: false,
                    title: that.$t("錯誤"),
                    text: error_msg[i18n.locale],
                    icon: "error",
                    allowOutsideClick: false,
                    willClose: function () {
                      // 移除登入資訊
                      Storage.remove("ek_login_token");
                      // 回到首頁
                      that.$router.push({
                        name: "Home",
                        params: {},
                      });
                    },
                  });
                } else {
                  that.$swal({
                    heightAuto: false,
                    title: that.$t("錯誤"),
                    text: error_msg[i18n.locale],
                    icon: "error",
                    allowOutsideClick: false,
                    confirmButtonText: that.$t("確定"),
                  });
                }
              }
            }
          },
        });
      } else {
        if (!isSilence) {
          that.$swal({
            heightAuto: false,
            title: that.$t("錯誤"),
            text: that.$t("沒有可上傳的步數資料"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
          });
        }
      }
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/CarbonReduction.vue